import { dehydrate } from "@tanstack/react-query";
import TrackListContainer from "@/components/container/HorseRacing/TrackListContainer";
import { Hr_PastTrack } from "@/graphql/gql/graphql";
import { getHorseTrackList } from "@/utils/api";
import { filterEmpty } from "@/utils/index";
import { loadHeader } from "@/utils/ssr";

const SEO_TITLE = "Comprehensive Horse Racing Track List";
const SEO_DESCRIPTION =
  "Comprehensive Horse Racing Track List: Complete List of all Major Horse Racing Tracks Around the World";

const Tracks = ({ raceTracks }: { raceTracks: Hr_PastTrack[] }) => (
  <TrackListContainer
    title={SEO_TITLE}
    description={SEO_DESCRIPTION}
    raceTracks={raceTracks}
  />
);

export async function getServerSideProps() {
  const menuClient = await loadHeader();
  const trackResults = await getHorseTrackList();
  const raceTracks = filterEmpty(trackResults.HS_PastTracks ?? []);
  return {
    props: {
      dehydratedState: dehydrate(menuClient),
      raceTracks,
      sportSlug: "horse-racing",
    },
  };
}

export default Tracks;
